import { DayPicker } from 'react-day-picker';
import styles from 'react-day-picker/dist/style.module.css';

import cx from 'classnames';
import moment, { Moment } from 'moment';

import Spinner from 'components/Spinner';

import { TDateSlot } from 'types/appointment';

import { CustomCaption } from './CustomCaption';

import s from './Calendar.module.css';

type Props = {
  selectedDay: Date | null;
  dateSlots: TDateSlot[];
  handleMonthChange: (date: Date) => void;
  handleDayClick: (date: Date) => void;
  loading?: boolean;
  showingError?: boolean;
};

const momentFormat = 'ddd MMM DD YYYY';
const weekdayLabels = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

const isDayInSlot = (day: Moment, slots: TDateSlot[]) => {
  if (!slots || slots.length === 0) {
    return false;
  }

  return slots.some((dateSlot) => moment(dateSlot.date).isSame(day, 'day'));
};

export const Calendar = ({
  selectedDay,
  dateSlots,
  loading,
  showingError,
  handleMonthChange,
  handleDayClick,
}: Props) => {
  const classNames = {
    ...styles,
    head_row: s.calendarHeadRow,
    root: `${styles.root} ${s.calendarRoot}`,
    caption_label: `${styles.caption_label} ${s.calendarCaption}`,
    day_selected: `${styles.day_selected} ${s.calendarSelectedDay}`,
    day_disabled: s.calendarDayDisabled,
    row: `${styles.row} ${s.calendarRow}`,
  };

  return (
    <>
      <DayPicker
        className={cx(showingError ? 'error' : '', loading ? 'loading' : '')}
        classNames={classNames}
        disabled={(day) => {
          const dayString = day.toDateString();

          const momentifiedDate = moment(dayString, momentFormat).startOf(
            'day',
          );

          return (
            !moment().startOf('day').isSameOrBefore(momentifiedDate) ||
            !isDayInSlot(momentifiedDate, dateSlots)
          );
        }}
        fromMonth={moment().startOf('month').add(1, 'd').toDate()}
        selected={(day) => {
          const dayString = day.toDateString();
          const momentifiedDate = moment(dayString, momentFormat).startOf(
            'day',
          );

          if (selectedDay) {
            return momentifiedDate.isSame(selectedDay);
          }
          return false;
        }}
        formatters={{
          formatWeekdayName: (weekday: Date) => weekdayLabels[weekday.getDay()],
        }}
        components={{
          Caption: (props) => <CustomCaption {...props} />,
        }}
        onMonthChange={handleMonthChange}
        onDayClick={handleDayClick}
      />
      <Spinner className={s.spinner} size="big" loading={loading} />
    </>
  );
};
